<script lang="ts">
  export let show: boolean;
  export let position: "right-bottom" | "right-top";
  export let margin: string = "";
  export let hide: () => void;

  $: hidden = !show;
</script>

<div class:hidden>
  <button class="wrapper" on:click={hide} />
  <div class={`content ${position}`} style={`margin: ${margin};`}>
    <slot />
  </div>
</div>

<style>
  .hidden {
    display: none;
  }

  .container {
    position: relative;
  }

  button {
    background: none;
    outline: none;
    margin: 0;
    padding: 0;
    border: none;
  }

  .wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    cursor: default !important;
  }
  .content {
    position: absolute;
    z-index: 1000; /* has to be equal or above .wrapper */
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    border-radius: 10px;
  }
  .content.right-bottom {
    left: 100%;
    bottom: 0;
  }
  .content.right-top {
    left: 100%;
    top: 0;
  }
</style>
